import React from "react";
import { CoachMarkerSetType } from "../../../../../Wrap/Models/Models/CoachMarkers/CoachMarkerSetType";
import { CoachMarkerStepPosition } from "../../../../Shared/CoachMarkers/CoachMarker";
import { ICoachMarkerPageConfig } from "../../../../Shared/CoachMarkers/CoachMarkerContext";

export enum BusinessManagementTab {
    AUM = "AUM",
    WrapperSummary = "Wrapper summary",
    Charges = "Adviser charges",
    ClientSummary = "Account summary",
}

export const BMContent = {
    FBRCWarning:
        'This does not include FBRC payments. Please use the "Commission Paying Accounts" report on the Adviser Management Info Reports screen to get this data',
};

export const AumContent = {
    title: "Assets under management",
    currentAssetHoldings: "Current asset holdings",
    pendingCashTransfersIn: "Pending cash transfers in",
    pendingAssetTransfersIn: "Pending asset transfers in",
    totalAssetHoldings: "Total asset holdings",
    figuresWarning:
        "Please note, these figures do not include any pending assets that are being sold or transferred from the platform.",
};

export const businessManagementCoachmarkerConfig: ICoachMarkerPageConfig = {
    coachMarkerSetType: CoachMarkerSetType.FnzOneBusinessManagement,
    steps: [
        {
            title: "Proposition type filter",
            stepPosition: CoachMarkerStepPosition.BottomLeft,
            stepKey: "business-management-client-filter",
            positionLeft: -320,
            positionTop: 60,
            description: (
                <>
                    This filter allows you to view business management information for all proposition types or by Wrap
                    or Fundzone clients (if applicable).
                </>
            ),
        },
    ],
};
